import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ISnackBarData } from '@dss-libs/shared/type/common-types';

@Component({
  selector: 'dss-libs-ui-snack-bar',
  imports: [MatIconModule],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackBarComponent {
  readonly snackBarRef = inject(MatSnackBarRef<SnackBarComponent>);
  readonly data: ISnackBarData = inject(MAT_SNACK_BAR_DATA);

  closeSnackBar(): void {
    this.snackBarRef.dismiss();
  }
}
